import FTeamSharePreview from './FTeamSharePreview.vue'

export default FTeamSharePreview
